var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubblesBlueMobilecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 340 323",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M157.828 84.178c-6.644 0-12.031 5.387-12.031 12.031 0 6.645 5.387 12.031 12.031 12.031 6.645 0 12.031-5.386 12.031-12.03 0-6.645-5.386-12.032-12.031-12.032z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M131.432 95.406a.401.401 0 100 .803.401.401 0 000-.803z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M157.828 130.609c-6.644 0-12.031 5.386-12.031 12.031 0 6.644 5.387 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M131.031 130.609c-6.645 0-12.031 5.386-12.031 12.031 0 6.644 5.386 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M144.426 107.574c-6.645 0-12.031 5.386-12.031 12.031 0 6.644 5.386 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M158.63 180.852a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M158.63 227.734a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M131.833 227.734a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M145.228 204.698a6.416 6.416 0 100 12.833 6.417 6.417 0 000-12.833z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M346.098 89.065a6.416 6.416 0 00-6.416 6.416 6.416 6.416 0 1012.833 0 6.417 6.417 0 00-6.417-6.416z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M332.696 66.03a6.417 6.417 0 100 12.833 6.417 6.417 0 000-12.834z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M346.098 135.496a6.416 6.416 0 100 12.832 6.416 6.416 0 000-12.832z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M332.696 112.461a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M345.48 180.851a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M332.078 157.815a6.416 6.416 0 100 12.834 6.416 6.416 0 000-12.834z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M345.48 227.732a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M332.078 204.696a6.416 6.416 0 100 12.832 6.416 6.416 0 000-12.832z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.022 41.23a8.02 8.02 0 10.001 16.04 8.02 8.02 0 00-.001-16.04z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M265.217 41.23a8.02 8.02 0 108.021 8.02 8.02 8.02 0 00-8.021-8.02z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M238.42 41.23a8.02 8.02 0 100 16.041 8.02 8.02 0 000-16.041z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M225.017 18.194a8.02 8.02 0 10.001 16.041 8.02 8.02 0 00-.001-16.041z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M319.301 89.065a6.417 6.417 0 100 12.833 6.417 6.417 0 000-12.833z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.022 87.461a8.02 8.02 0 10.001 16.041 8.02 8.02 0 00-.001-16.041z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M265.217 87.461a8.02 8.02 0 108.021 8.02 8.02 8.02 0 00-8.021-8.02z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M238.283 84.178c-6.644 0-12.031 5.387-12.031 12.031 0 6.645 5.387 12.031 12.031 12.031 6.645 0 12.031-5.386 12.031-12.03 0-6.645-5.386-12.032-12.031-12.032z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M305.417 64.425a8.02 8.02 0 10.001 16.042 8.02 8.02 0 00-.001-16.042z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M278.612 64.425a8.02 8.02 0 108.021 8.021 8.02 8.02 0 00-8.021-8.02z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M251.815 64.425a8.02 8.02 0 100 16.042 8.02 8.02 0 000-16.042z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M225.017 64.425a8.02 8.02 0 10.001 16.042 8.02 8.02 0 00-.001-16.042z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M318.82 133.893a8.02 8.02 0 100 16.041 8.02 8.02 0 000-16.041z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.022 133.893a8.02 8.02 0 100 16.04 8.02 8.02 0 000-16.04z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M265.883 134.621a6.416 6.416 0 100 12.832 6.416 6.416 0 000-12.832z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M238.283 130.609c-6.644 0-12.031 5.386-12.031 12.031 0 6.644 5.387 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M305.417 110.857a8.02 8.02 0 10.001 16.041 8.02 8.02 0 00-.001-16.041z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M278.612 110.857a8.02 8.02 0 100 16.042 8.02 8.02 0 000-16.042z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M251.678 107.574c-6.644 0-12.031 5.386-12.031 12.031 0 6.644 5.387 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M224.882 107.574c-6.645 0-12.031 5.386-12.031 12.031 0 6.644 5.386 12.031 12.031 12.031 6.644 0 12.031-5.387 12.031-12.031 0-6.645-5.387-12.031-12.031-12.031z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M318.684 180.851a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.022 185.16a3.208 3.208 0 100 6.417 3.208 3.208 0 000-6.417z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M289.937-.965a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M265.218 185.16a3.21 3.21 0 100 6.418 3.21 3.21 0 000-6.418z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M263.132-.965a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M316.578-.965a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M316.578 44.449a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M239.086 180.852a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M305.417 162.124a3.209 3.209 0 10.001 6.417 3.209 3.209 0 00-.001-6.417z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M278.612 162.124a3.209 3.209 0 10.001 6.417 3.209 3.209 0 00-.001-6.417z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M252.48 157.818a6.417 6.417 0 10.001 12.833 6.417 6.417 0 00-.001-12.833z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M225.683 157.818a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M318.684 227.732a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.022 232.041a3.209 3.209 0 10.001 6.417 3.209 3.209 0 00-.001-6.417z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M265.218 232.041a3.21 3.21 0 100 6.419 3.21 3.21 0 000-6.419z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M238.42 232.041a3.209 3.209 0 10.001 6.417 3.209 3.209 0 00-.001-6.417z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M305.281 204.696a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M278.612 209.006a3.208 3.208 0 100 6.415 3.208 3.208 0 000-6.415z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M276.527 22.88a3.209 3.209 0 100 6.417 3.209 3.209 0 000-6.417z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M329.973 22.88a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M251.815 209.006a3.209 3.209 0 10-.001 6.417 3.209 3.209 0 00.001-6.417z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M249.73 22.88a3.209 3.209 0 100 6.417 3.209 3.209 0 000-6.417z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M303.176 22.88a3.208 3.208 0 100 6.416 3.208 3.208 0 000-6.416z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M225.683 204.698a6.416 6.416 0 100 12.833 6.417 6.417 0 000-12.833z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M211.679 41.23a8.02 8.02 0 10.001 16.04 8.02 8.02 0 00-.001-16.04z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M184.874 41.23a8.02 8.02 0 108.021 8.02 8.02 8.02 0 00-8.021-8.02z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M211.543 84.178c-6.645 0-12.031 5.387-12.031 12.031 0 6.645 5.386 12.031 12.031 12.031 6.644 0 12.031-5.386 12.031-12.03 0-6.645-5.387-12.032-12.031-12.032z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M184.737 84.178c-6.644 0-12.031 5.387-12.031 12.031 0 6.645 5.387 12.031 12.031 12.031 6.645 0 12.032-5.386 12.032-12.03 0-6.645-5.387-12.032-12.032-12.032z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M198.133 61.142c-6.645 0-12.032 5.387-12.032 12.032 0 6.644 5.387 12.03 12.032 12.03 6.644 0 12.031-5.386 12.031-12.03 0-6.645-5.387-12.032-12.031-12.032z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M171.335 61.142c-6.644 0-12.031 5.387-12.031 12.032 0 6.644 5.387 12.03 12.031 12.03 6.645 0 12.031-5.386 12.031-12.03 0-6.645-5.386-12.032-12.031-12.032z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M211.543 130.609c-6.645 0-12.031 5.386-12.031 12.031 0 6.644 5.386 12.031 12.031 12.031 6.644 0 12.031-5.387 12.031-12.031 0-6.645-5.387-12.031-12.031-12.031z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M184.737 130.609c-6.644 0-12.031 5.386-12.031 12.031 0 6.644 5.387 12.031 12.031 12.031 6.645 0 12.032-5.387 12.032-12.031 0-6.645-5.387-12.031-12.032-12.031z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M198.133 107.574c-6.645 0-12.032 5.386-12.032 12.031 0 6.644 5.387 12.031 12.032 12.031 6.644 0 12.031-5.387 12.031-12.031 0-6.645-5.387-12.031-12.031-12.031z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M171.335 107.574c-6.644 0-12.031 5.386-12.031 12.031 0 6.644 5.387 12.031 12.031 12.031 6.645 0 12.031-5.387 12.031-12.031 0-6.645-5.386-12.031-12.031-12.031z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M212.345 180.852a6.416 6.416 0 100 12.832 6.416 6.416 0 000-12.832z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M185.539 180.852a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M198.935 157.818a6.417 6.417 0 100 12.834 6.417 6.417 0 000-12.834z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.137 157.818a6.416 6.416 0 100 12.834 6.416 6.416 0 000-12.834z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M211.679 232.041a3.21 3.21 0 10.002 6.418 3.21 3.21 0 00-.002-6.418z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M185.539 227.734a6.417 6.417 0 10.002 12.834 6.417 6.417 0 00-.002-12.834z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M198.935 204.698a6.416 6.416 0 10-.002 12.832 6.416 6.416 0 00.002-12.832z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.137 204.698a6.416 6.416 0 106.417 6.416 6.416 6.416 0 00-6.417-6.416z"
  })));
}

export default __webpack_public_path__ + "bubbles-blue-mobile.colors.f409ca97.svg";
export { SvgBubblesBlueMobilecolors as ReactComponent };